import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: 'Do you offer local moving near me in Southern California?',
    a: 'Yes! City to City Moving Company serves all of Southern California from three local offices. We cover Orange County (including Irvine, Newport Beach, Anaheim), the Coachella Valley (Indio, Palm Springs, Palm Desert), and the Long Beach/South Bay area. If you\'re in SoCal, we\'re your local movers.',
  },
  {
    q: 'What areas does City to City Moving Company serve?',
    a: 'We serve the entire Southern California region including Orange County, Los Angeles County, the Coachella Valley, Inland Empire, and South Bay. Our three offices are based in Irvine, Indio, and Long Beach. We also provide long-distance moving service to all 50 states.',
  },
  {
    q: 'Do you handle long-distance moves from Southern California?',
    a: 'Yes. We move clients from Southern California to any state in the U.S. We offer binding estimates, real-time tracking, and a dedicated coordinator for every long-distance move. Popular destinations include Nevada, Arizona, Texas, Oregon, Washington, and Colorado.',
  },
  {
    q: 'Do you provide office movers in my area?',
    a: 'Absolutely. Our commercial moving division operates across all our service areas in Southern California. We handle office relocations, retail moves, and warehouse transitions — often scheduling after-hours or on weekends to minimize business disruption.',
  },
  {
    q: 'Can you move me from the Coachella Valley to another city?',
    a: 'Yes. Our Coachella Valley team handles local moves throughout Indio, Palm Springs, Palm Desert, La Quinta, and surrounding desert communities, as well as moves to and from Orange County, LA, and long-distance destinations nationwide.',
  },
  {
    q: 'Do you serve cities outside of your main office areas?',
    a: 'Yes. While our offices are in Irvine, Indio, and Long Beach, we serve a much wider coverage area throughout Southern California. If you\'re unsure whether we serve your city, just call (760) 625-7767 and we\'ll confirm availability.',
  },
];

const longDistanceStates = [
  'Nevada', 'Arizona', 'Oregon', 'Washington', 'Texas', 'Colorado', 'Utah',
  'Idaho', 'New Mexico', 'Montana', 'Wyoming', 'Florida', 'New York', 'Georgia', 'North Carolina',
];

export default function LocationsFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  return (
    <>
      {/* Services Available Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="inline-block bg-orange-100 text-orange-600 text-sm font-bold px-4 py-2 rounded-full mb-4">
              Available Everywhere We Serve
            </span>
            <h2 className="text-3xl font-black text-slate-900 mb-3">Full Moving Services in Every Area</h2>
            <p className="text-slate-600 max-w-2xl mx-auto">No matter which of our service areas you\'re in, you get access to our complete suite of professional moving services.</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
            {[
              { icon: 'ri-home-move-line', title: 'Residential Moving', desc: 'Full home moves, apartments, condos' },
              { icon: 'ri-home-4-line', title: 'Local Moving', desc: 'Within SoCal, same-day available' },
              { icon: 'ri-route-line', title: 'Long-Distance Moving', desc: 'All 50 states, binding estimates' },
              { icon: 'ri-building-4-line', title: 'Commercial Moving', desc: 'Office, retail, warehouse moves' },
              { icon: 'ri-archive-2-line', title: 'Packing & Unpacking', desc: 'Full or partial packing services' },
              { icon: 'ri-upload-cloud-2-line', title: 'Loading & Unloading', desc: 'Labor for your truck or container' },
              { icon: 'ri-vip-crown-2-line', title: 'Specialty Items', desc: 'Pianos, art, antiques, oversized' },
              { icon: 'ri-magic-2-line', title: 'Full-Service Moving', desc: 'Pack, move, unpack — everything' },
            ].map((item) => (
              <div key={item.title} className="bg-white rounded-2xl p-5 border border-gray-100 hover:-translate-y-1 transition-all duration-300 text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-50 rounded-xl mx-auto mb-4">
                  <i className={`${item.icon} text-xl text-orange-500`}></i>
                </div>
                <h3 className="font-black text-slate-900 text-sm mb-1">{item.title}</h3>
                <p className="text-slate-500 text-xs">{item.desc}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-10">
            <Link to="/services"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 text-white px-8 py-4 rounded-xl font-bold hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap">
              <i className="ri-grid-line text-lg"></i>View All Services in Detail
            </Link>
          </div>
        </div>
      </section>

      {/* Long Distance Section */}
      <section className="py-16 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="inline-block bg-amber-500/20 text-amber-400 text-sm font-bold px-4 py-2 rounded-full mb-5">
                Not Just Local
              </span>
              <h2 className="text-3xl md:text-4xl font-black text-white mb-5">We Move You Anywhere in the U.S.</h2>
              <p className="text-slate-400 text-base leading-relaxed mb-6">
                Moving out of California? City to City Moving Company handles long-distance and interstate moves to all 50 states. Same care. Same team. Same commitment to making your move great — no matter how far.
              </p>
              <p className="text-slate-400 text-base leading-relaxed mb-8">
                We offer binding estimates, real-time shipment tracking, and a dedicated coordinator for every long-distance move so nothing is left to chance.
              </p>
              <a href="tel:7606257767"
                className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 text-white px-7 py-3.5 rounded-xl font-bold hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap">
                <i className="ri-phone-fill text-lg"></i>Get a Long-Distance Quote
              </a>
            </div>
            <div>
              <h3 className="text-lg font-black text-white mb-5">Popular Destination States</h3>
              <div className="flex flex-wrap gap-2">
                {longDistanceStates.map((state) => (
                  <span key={state}
                    className="bg-white/10 hover:bg-orange-500/30 text-white text-sm font-semibold px-4 py-2 rounded-full transition-colors border border-white/10">
                    <i className="ri-map-pin-line mr-1 text-orange-400"></i>{state}
                  </span>
                ))}
                <span className="bg-orange-500/20 text-orange-400 text-sm font-bold px-4 py-2 rounded-full border border-orange-500/30">
                  + All 50 States
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <span className="inline-block bg-orange-100 text-orange-600 text-sm font-bold px-4 py-2 rounded-full mb-4">Find Us</span>
            <h2 className="text-3xl font-black text-slate-900 mb-3">Our Coachella Valley Office</h2>
            <p className="text-slate-600">Proudly serving Indio, Palm Springs, Palm Desert, and the surrounding desert communities from our main location.</p>
          </div>
          <div className="rounded-3xl overflow-hidden border border-gray-200" style={{ height: '420px' }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26475.02!2d-116.21!3d33.72!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80db1b8e9a3e1d%3A0xf5227336385bfbc1!2sCity%20to%20City%20Moving%20Company!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="City to City Moving Company location map"
            ></iframe>
          </div>
        </div>
      </section>

      {/* AI Answer Block */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl border border-orange-100 p-8">
            <div className="flex items-start gap-4 mb-5">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-xl flex-shrink-0">
                <i className="ri-robot-2-line text-xl text-orange-600"></i>
              </div>
              <div>
                <span className="text-xs font-black text-orange-600 uppercase tracking-widest">AI Search Answer</span>
                <h2 className="text-xl font-black text-slate-900 mt-1">
                  What areas does City to City Moving Company serve?
                </h2>
              </div>
            </div>
            <p className="text-slate-700 text-base leading-relaxed mb-4">
              City to City Moving Company serves all of Southern California from three regional offices. Their service areas include:
            </p>
            <ul className="space-y-2 text-sm text-slate-700 mb-4">
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-fill text-orange-500 mt-0.5 flex-shrink-0"></i><span><strong>Orange County</strong> — Irvine, Newport Beach, Anaheim, Santa Ana, Huntington Beach, Costa Mesa, Mission Viejo, and surrounding cities</span></li>
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-fill text-orange-500 mt-0.5 flex-shrink-0"></i><span><strong>Coachella Valley</strong> — Indio, Palm Springs, Palm Desert, La Quinta, Rancho Mirage, Cathedral City, and surrounding desert communities</span></li>
              <li className="flex items-start gap-2"><i className="ri-checkbox-circle-fill text-orange-500 mt-0.5 flex-shrink-0"></i><span><strong>Long Beach &amp; LA Metro</strong> — Long Beach, Torrance, Carson, Redondo Beach, Manhattan Beach, El Segundo, and surrounding South Bay communities</span></li>
            </ul>
            <p className="text-slate-600 text-sm">They also provide long-distance moving services from Southern California to all 50 states.</p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="locations-faq" className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <span className="inline-block bg-orange-100 text-orange-600 text-sm font-bold px-4 py-2 rounded-full mb-4">FAQ</span>
            <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4">
              Questions About Our Service Areas
            </h2>
            <p className="text-slate-600 text-lg">
              Wondering if we serve your area? Here are the answers to our most common location questions.
            </p>
          </div>
          <div className="space-y-3 mb-14">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-slate-50 rounded-2xl border border-slate-200 overflow-hidden">
                <button
                  onClick={() => toggle(i)}
                  className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-slate-100 transition-colors"
                >
                  <span className="font-bold text-slate-900 text-sm leading-snug pr-4">{faq.q}</span>
                  <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${openIndex === i ? 'bg-orange-500 text-white' : 'bg-white text-slate-500 border border-slate-200'}`}>
                    <i className={`text-sm ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </div>
                </button>
                {openIndex === i && (
                  <div className="px-6 pb-5">
                    <p className="text-slate-600 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Final CTA */}
          <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-3xl p-10 text-center">
            <h3 className="text-2xl font-black text-white mb-3">Moving in Southern California?</h3>
            <p className="text-orange-100 mb-7">Contact your nearest City to City office for a free, no-obligation quote. Available 7 days a week, 9 AM–5 PM.</p>
            <div className="flex flex-wrap justify-center gap-4">
              <a href="tel:7606257767"
                className="flex items-center gap-2 bg-white text-orange-600 px-8 py-4 rounded-xl font-bold hover:scale-105 transition-all whitespace-nowrap">
                <i className="ri-phone-fill text-xl"></i>(760) 625-7767
              </a>
              <Link to="/services"
                className="flex items-center gap-2 bg-slate-900 text-white px-8 py-4 rounded-xl font-bold hover:bg-slate-800 transition-all whitespace-nowrap">
                <i className="ri-grid-line text-xl"></i>View Our Services
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
